import { UIViewSpec } from './view';

export type UIScrollHandler = (event: Event) => void;

declare global {
    interface Element {
        ui_scroll_handlers?: UIScrollHandler[];
    }
}

let scroll_init = false;

function initScroll() {
    document.addEventListener('scroll', e => {
        for(const l of document.getElementsByClassName('v-scroll')) {
            for(const h of l.ui_scroll_handlers!) {
                h(e);
            }
        }
    });

    scroll_init = true;
}

export function onScroll(where: UIViewSpec, handler: UIScrollHandler) {
    if(!scroll_init)
        initScroll();

    where = where.ui_elem;

    if(where.ui_scroll_handlers)
        where.ui_scroll_handlers.push(handler);
    else
        where.ui_scroll_handlers = [handler];

    where.classList.add('v-scroll');
}
